// @flow
import React from 'react';
import { Query, type QueryRenderProps } from '@apollo/client/react/components';
import { Text } from 'primitive-components';

import SegmentCategoryManager from './SegmentCategoryManager';
import { GET_SEGMENT_CATEGORIES, GET_CLIENT_SEGMENT_CATEGORIES } from './queries';
import type {
  GetSegmentCategoriesResponse,
  GetClientSegmentCategoriesVariables,
  GetClientSegmentCategoriesResponse,
} from './types';

type SegmentCategoryManagerContainerProps = {
  clientId: string,
};

const SegmentCategoryManagerContainer = ({ clientId }: SegmentCategoryManagerContainerProps) => (
  <Query query={GET_SEGMENT_CATEGORIES}>
    {(getSegmentCategories: QueryRenderProps<GetSegmentCategoriesResponse>) => (
      <Query query={GET_CLIENT_SEGMENT_CATEGORIES} variables={{ clientId }}>
        {(
          getClientSegmentCategories: QueryRenderProps<
            GetClientSegmentCategoriesResponse,
            GetClientSegmentCategoriesVariables,
          >,
        ) => {
          if (getSegmentCategories.loading || getClientSegmentCategories.loading) {
            return <Text align="center">Loading business areas...</Text>;
          }

          if (getSegmentCategories.error || getClientSegmentCategories.error) {
            return <Text align="center">There was a problem loading business areas</Text>;
          }

          const clientSegmentCategories =
            (getClientSegmentCategories.data &&
              getClientSegmentCategories.data.client &&
              getClientSegmentCategories.data.client.segmentCategories) ||
            [];

          const segmentCategories =
            (getSegmentCategories.data && getSegmentCategories.data.segmentCategories) || [];

          return (
            <SegmentCategoryManager
              clientId={clientId}
              segmentCategories={segmentCategories}
              clientSegmentCategories={clientSegmentCategories}
            />
          );
        }}
      </Query>
    )}
  </Query>
);

export default SegmentCategoryManagerContainer;
